export const CURRENT_RETAILER = 'CURRENT_RETAILER';
export const CURRENT_RETAILER_LOADING = 'CURRENT_RETAILER_LOADING';
export const CURRENT_RETAILER_WAREHOUSES = 'CURRENT_RETAILER_WAREHOUSES';
export const CURRENT_RETAILER_UPDATE = 'CURRENT_RETAILER_UPDATE';
export const CURRENT_RETAILER_TAB = 'CURRENT_RETAILER_TAB';
